//////// GHG 1.3 EF
const oneThreeSchema = {
  title: "1.3 Direct Emissions from Process Sources",
  cat: "1_3",
  catName: "cat1",
  progressiveOrderSwitch: {
    by: { level: 2, key: "sourceEFName" }, // 觀察誰
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
    },
    ////////Data Source (emissionFactorTypeId)
    {
      key: "emissionFactorTypeId",
      level: 1,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
    },
    ////////Emission Factor Database Source
    {
      key: "sourceEFName",
      level: 2,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        value: "1_1",
      },
      showIf: { level: 1, key: "emissionFactorTypeId", ne: "2" },
      combineKey: 1,
    },
    ////////Types of Process (typesOfProcess)
    {
      key: "typesOfProcess",
      level: 3,
      type: "select",
      label: "Type of Process",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "sourceEFName",
      },
      showIf: {
        level: 2,
        key: "sourceEFName",
        notEmpty: true,
      },
      combineKey: 2,
    },
    ////////Emission Factor Name (非自定義)
    {
      key: "emissionFactorId",
      level: 4,
      type: "select",
      label: "Feedstock / Process / Emission Stream",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "typesOfProcess",
      },
      showIf: {
        level: 3,
        key: "typesOfProcess",
        notEmpty: true,
      },
      combineKey: 3,
    },
    ////////Emission Factor Name (非自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 4,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat1CustomEFDropdownList",
      showIf: {
        level: 1,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum: 0,
    },
  ],
};

export default oneThreeSchema;
